module.exports = __webpack_public_path__ + "images/skewness-14-desktop.png";